export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = "";
export const RECORDS_LIMIT = recordsLimit;

export const falsyArray = [
  null,
  undefined,
  "",
  0,
  false,
  NaN,
  "null",
  "undefined",
  "false",
  "0",
  "NaN",
];
export const fileTypesAllowed = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "video/mp4",
  "video/mpeg",
  "video/quicktime",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
export const videoFileTypes = ["mp4", "mpeg", "quicktime"];

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};
export const allowedDocTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};
export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};
export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "system-deactivated",
};
export const POST_TYPE = {
  PRODUCER: "producer",
  CONSUMER: "consumer",
  NEW_POST: "content",
  SHARE: "share",
};
// Mirrors TRADE_INTENT in the backend feed-preferences enums file.
export const TRADE_INTENT = {
  SUPPLIER: "supplier",
  END_USER: "end-user",
  TRADER: "trader",
};
export const TRADE_INTENT_LABEL = {
  [TRADE_INTENT.SUPPLIER]: "Looking for suppliers",
  [TRADE_INTENT.END_USER]: "Looking for end users",
  [TRADE_INTENT.TRADER]: "Trader — interested in both sides",
};
export const REQUEST_EDIT_STATUS = {
  PENDING: "pending",
  ACCEPT: "accept",
  REJECT: "reject",
};
export const IMAGE_MIME_TYPES = ["jpg", "jpeg", "png"];
export const VIDEO_MIME_TYPES = ["mp4"];
export const CSV_MIME_TYPES = ["csv"];
export const PDF_MIME_TYPES = ["pdf"];
export const DOC_MIME_TYPES = ["doc", "docx"];
export const INTERVAL = {
  MONTHLY: "month",
  YEARLY: "year",
};

export const SYSTEM_SETTINGS_KEY = {
  CONFIG: "config",
};
export const csvFields = [
  "type",
  "product",
  "plant",
  "country",
  "capacity",
  "tradeLocally",
  "tradeInternationally",
  "captiveUsed",
];
export const NOTIFICATION_FLAG = {
  NONE: "none",
  CHAT: "chat",
  POST_LIKE: "post-like",
  POST_SHARE: "post-share",
  POST_COMMENT: "post-comment",
  COMMENT_REPLY: "comment-reply",
  COMMENT_LIKE: "comment-like",
  REPLY_LIKE: "reply-like",
  FOLLOW_REQUEST: "follow-request",
};
